
<!--  -->
<template>
  <div class="container">
    <div class="item">
      <div class="title" @click="ifshow">
        {{course_name}}
        <i class="iconfont icon-gantanhao"></i>
      </div>
      <div class="content">
        <div class="much">点击图片长按保存至手机</div>
        <div class="img">
          <div class="box" :style="{marginRight:i%2==0?'0.8%':'0'}" v-for="(item,i) in imgList" :key="i" @click="getImg(i)">
            <img
              :src="'https://www.jspx0769.com'+item.url"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <div class="showInfo" v-show="isshow == true">
      <div class="show_content">
        <div class="hide">温馨提示</div>
        <div class="hide_content">
          <div class="hide_title">课程培训报名步骤 :</div>
          <div class="hide_item">① 下载报名资料模板，将报名表等资料打印出来；</div>
          <div class="hide_item">② 填写并完善个人资料，注意字迹工整；</div>
          <div class="hide_item">③ 将每一张报名表用手机拍照，照片无遮挡，图片 清晰，可识别，使报名表居于照片中央；</div>
          <div class="hide_item">④ 选择对应的课程班期，点击报名上传，等待审核。</div>
        </div>
      </div>
      <i class="iconfont icon-roundclose" v-show="isshow == true" @click="hide"></i>
    </div>
    <div class="mask" v-show="isshow == true"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { ImagePreview } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      isshow: false,
      imgList: [],
      arr: [],
      course_name:""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    hide() {
      this.isshow = false;
    },
    ifshow() {
      this.isshow = true;
    },
    getInfo() {
      let id = this.$route.query.id;
      this.$toast.loading({ message: "加载中" });
      this.$http.getSignDataList({ course_id: id }).then(res => {
        this.$toast.clear();
        if (res.status == 1) {
          let arr = [];
          res.data.map((current, index) => {
            arr[index] = "https://www.jspx0769.com" + current.url;
          });
          this.imgList = res.data;
          this.arr = arr;
          // this.imgList = this.imgList
        }
      });
    },
    // 点击预览图片
    getImg(index) {
      ImagePreview({
        images: this.arr,
        showIndex: true,
        loop: false,
        closeOnPopstate: true,
        cover: "哈哈哈哈哈",
        index: index,
        startPosition: index,
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo();
    this.course_name = this.$route.query.course_name
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.container {
  background-color: #f5f5f5;
  width: 100%;
  height: 100vh;
  position: relative;
  .item {
    width: 100%;
    background-color: #fff;
    padding: 0 15px;
    box-sizing: border-box;
    .title {
      width: 100%;
      padding: 10px 0px;
      box-sizing: border-box;
      border-bottom: 1px solid #dddddd;
      color: #333333;
      font-size: 16px;
      .iconfont {
        color: #b7b7b9;
      }
    }
    .content {
      width: 100%;
      .much {
        font-size: 14px;
        color: #666666;
        margin-top: 7px;
      }
      .img {
        width: 100%;
        margin-top: 10px;
        .box {
          display: inline-block;
          border: 1px solid #666;
          width: 49%;
          margin-bottom: 10px;
          height: 303px;
          line-height: 303px;
          position: relative;
          img {
            width: 98%;
            height: 98%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
          }
        }
        .margin{
          margin-left: 1%
        }
      }
    }
  }
  .showInfo {
    width: 90%;
    // background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: 10;

    .show_content {
      background-color: #fff;
      padding-bottom: 10px;
      box-sizing: border-box;
      border-radius: 10px;
      .hide {
        border-bottom: 1px solid #eaeaea;
        text-align: center;
        padding: 10px 0px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
      .hide_content {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        .hide_title {
          font-size: 15px;
          color: #333333;
          padding: 7px 0;
          box-sizing: border-box;
        }
        .hide_item {
          color: #666666;
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
    .icon-roundclose {
      margin-top: 20px;
      z-index: 10;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 24px;
      color: #fff;
    }
  }
  .mask {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>